import { render } from "./MainMenu.vue?vue&type=template&id=3dcadd6c&ts=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__